import { createContext, useContext } from 'react';

interface FeedbackContextValue {
  accountToken?: string;
  apiHost?: string;
  mfeVersion?: string;
  reDisplayAfterDays?: string;
}

const FeedbackContext = createContext<FeedbackContextValue>({});

export function FeedbackProvider({
  accountToken,
  apiHost,
  mfeVersion,
  reDisplayAfterDays,
  children,
}: FeedbackContextValue & { children: React.ReactNode }) {
  return (
    <FeedbackContext.Provider value={{ accountToken, apiHost, mfeVersion, reDisplayAfterDays }}>
      {children}
    </FeedbackContext.Provider>
  );
}

export function useFeedbackConfig() {
  return useContext(FeedbackContext);
}
